// @ts-ignore
export const IS_DEV = process.env.NODE_ENV === 'development';
// @ts-ignore
export const IS_TEST = process.env.REACT_APP_EXEC_ENV === 'test';

export const DAY_SHOWS_LIMIT = 10;
